<app-loader [isLoading]="isLoading" loaderText="Cargando certificados"></app-loader>
<div mat-dialog-content class="auth-dialog-body" role="dialog" aria-modal="true" aria-labelledby="auth-modal-title" aria-describedby="auth-modal-description">
  <!-- Header sin botón cerrar -->
  <div class="dialog-header">
    <div class="header-icon-wrapper">
      <img src="assets/icons/shield-icon.svg" alt="Icono de escudo" class="header-icon-img" />
    </div>
    <h3 id="auth-modal-title">Autenticación Certifirma Digital Virtual</h3>
    <p id="auth-modal-description" class="dialog-header-subtitle">Ingrese sus credenciales para acceder a sus certificados digitales.</p>
  </div>
  
  <!-- Formulario de autenticación -->
  <div *ngIf="!isAuthenticated" class="auth-form-content">
    <label for="nuip-input" class="label-document">Usuario *</label>
    <div class="auth-input-wrap">
      <input
        type="text"
        id="nuip-input"
        [(ngModel)]="nuip"
        name="nuip"
        class="auth-input"
        placeholder="Ingrese su usuario"
        aria-required="true"
        aria-describedby="nuip-help"
        autocomplete="username"
        cdkFocusInitial />
    </div>

    <label for="password-input" class="label-document">Contraseña *</label>
    <div class="auth-input-wrap auth-input-wrap-password">
      <input
        type="text"
        id="password-input"
        [(ngModel)]="password"
        name="password"
        class="auth-input"
        [class.auth-input-masked]="!passwordVisible"
        placeholder="Ingrese contraseña"
        aria-required="true"
        aria-describedby="password-help password-toggle-desc"
        [attr.aria-label]="passwordVisible ? 'Contraseña visible' : 'Contraseña oculta'"
        autocomplete="current-password" />
      <button
        type="button"
        class="password-toggle-btn"
        (mousedown)="passwordVisible = true"
        (mouseup)="passwordVisible = false"
        (mouseleave)="passwordVisible = false"
        (touchstart)="passwordVisible = true; $event.preventDefault()"
        (touchend)="passwordVisible = false"
        (touchcancel)="passwordVisible = false"
        (pointerdown)="passwordVisible = true"
        (pointerup)="passwordVisible = false"
        (pointercancel)="passwordVisible = false"
        tabindex="0"
        [attr.aria-label]="'Mantenga pulsado para ver la contraseña'">
        <i class="fas fa-eye" aria-hidden="true"></i>
      </button>
      <span id="password-toggle-desc" class="sr-only">Mantenga pulsado el botón del ojo para ver la contraseña</span>
    </div>

    <div class="button-container">
      <button 
        class="btn btn-secondary" 
        (click)="closeDialog()"
        type="button"
        [disabled]="isLoading"
        [attr.aria-disabled]="isLoading"
        aria-label="Cancelar autenticación y cerrar modal">
        Cancelar
      </button>
      <button 
        class="btn btn-primary" 
        (click)="submitCredentials()" 
        [disabled]="isLoading"
        type="button"
        [attr.aria-label]="isLoading ? 'Cargando certificados...' : 'Ingresar con credenciales para acceder a certificados'"
        [attr.aria-busy]="isLoading">
        <span *ngIf="!isLoading">Ingresar</span>
        <span *ngIf="isLoading" aria-hidden="true">Cargando...</span>
      </button>
    </div>
  </div>

  <!-- Lista de certificados -->
  <div *ngIf="isAuthenticated && data.certificates.length > 0" class="certificates-content">
    <p class="label-document" tabindex="-1" cdkFocusInitial>Seleccione un certificado para firmar</p>
    <div class="certificate-list">
      <div 
        class="certificate-item" 
        *ngFor="let cert of data.certificates" 
        (click)="selectCertificate(cert)"
        [class.selected]="selectedCertificate === cert"
        role="button"
        tabindex="0"
        [attr.aria-label]="'Certificado: ' + cert.cn + ', Organización: ' + cert.o + ', Vence: ' + cert.validity.notAfter"
        [attr.aria-pressed]="selectedCertificate === cert"
        (keydown.enter)="selectCertificate(cert)"
        (keydown.space)="selectCertificate(cert); $event.preventDefault()">
        <img 
          *ngIf="selectedCertificate !== cert"
          src="assets/icons/certificate-icon-unselected.svg" 
          alt="Icono de certificado digital" 
          class="certificate-logo" />
        <img 
          *ngIf="selectedCertificate === cert"
          src="assets/icons/certificate-icon-selected.svg" 
          alt="Icono de certificado digital seleccionado" 
          class="certificate-logo" />
        <div class="certificate-info">
          <p class="certificate-title">{{ cert.cn }}</p>
          <p class="certificate-field">Organización: {{ cert.o }}</p>
          <p class="certificate-field">Proyecto: {{ cert.ou }}</p>
          <p class="certificate-field">Serial: {{ cert.serial }}</p>
          <p class="expiry-date">Vence: {{ cert.validity.notAfter }}</p>
        </div>
      </div>
    </div>
    <div class="button-container">
      <button 
        class="btn btn-secondary" 
        (click)="goBack()"
        type="button"
        aria-label="Volver a la vista de usuario y contraseña">
        Volver
      </button>
      <button 
        class="btn btn-primary" 
        (click)="confirmSelection()" 
        [disabled]="!selectedCertificate"
        type="button"
        [attr.aria-label]="selectedCertificate ? 'Firmar documentos con certificado seleccionado: ' + selectedCertificate.cn : 'Seleccione un certificado para continuar'"
        [attr.aria-disabled]="!selectedCertificate">
        Firmar Documentos
      </button>
    </div>
  </div>

  <!-- Sin certificados -->
  <div *ngIf="isAuthenticated && data.certificates.length === 0" class="empty-state-content">
    <p style="padding: var(--space-6); text-align: center; color: var(--text-secondary);">
      No hay certificados disponibles para este usuario.
    </p>
    <div class="button-container">
      <button 
        class="btn btn-secondary" 
        (click)="goBack()"
        type="button"
        aria-label="Volver a la vista de usuario y contraseña">
        Volver
      </button>
    </div>
  </div>
</div>
